// extracted by mini-css-extract-plugin
export default {"textBlock":"QuestionSimpleText_textBlock__UwEtH"};